import React, { useState, useEffect } from 'react';
import io from 'socket.io-client';

// Remove /api apenas do FINAL da URL (regex $) para não quebrar o https://api...
const API_BASE_URL = process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '')
    : 'https://api.ofertiz.com.br';
const QueueStatus = () => {
    const [queueState, setQueueState] = useState({
        size: 0,
        isProcessing: false
    });
    const [currentItem, setCurrentItem] = useState(null);
    const [lastError, setLastError] = useState(null);

    useEffect(() => {
        // Conecta ao socket usando a URL base da API
        const socket = io(API_BASE_URL, {
            reconnection: true,
            reconnectionAttempts: 5,
            reconnectionDelay: 1000
        });

        // Listen for queue updates
        socket.on('queue_update', (data) => {
            setQueueState(data);
        });

        socket.on('queue_item_start', (data) => {
            setCurrentItem(data);
            setLastError(null);
        });

        socket.on('queue_item_complete', () => {
            setCurrentItem(null);
        });

        socket.on('queue_item_error', (data) => {
            setLastError(data.error);
            setCurrentItem(null);
        });

        return () => {
            socket.disconnect();
        };
    }, []);

    const handleControl = async (action) => {
        try {
            await fetch(`${API_URL}/api/queue/${action}`, { method: 'POST' });
        } catch (error) {
            console.error(`Erro ao executar ${action}:`, error);
            alert(`Erro ao executar ação: ${action}`);
        }
    };

    if (queueState.size === 0 && !queueState.isProcessing) {
        return null;
    }

    return (
        <div style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            backgroundColor: 'white',
            padding: '15px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            zIndex: 1000,
            width: '320px',
            border: '1px solid #e0e0e0'
        }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                <h4 style={{ margin: 0, fontSize: '1rem' }}>
                    <i className="fas fa-layer-group" style={{ color: 'var(--primary-color)' }}></i> Fila de Envio
                </h4>
                <span style={{
                    backgroundColor: queueState.isProcessing ? '#d4edda' : '#fff3cd',
                    color: queueState.isProcessing ? '#155724' : '#856404',
                    padding: '2px 8px',
                    borderRadius: '12px',
                    fontSize: '0.75rem',
                    fontWeight: 'bold'
                }}>
                    {queueState.isProcessing ? 'ENVIANDO' : 'PAUSADO'}
                </span>
            </div>

            <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
                {!queueState.isProcessing ? (
                    <button
                        onClick={() => handleControl('resume')}
                        style={{ flex: 1, padding: '8px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                    >
                        <i className="fas fa-play"></i> Retomar
                    </button>
                ) : (
                    <button
                        onClick={() => handleControl('pause')}
                        style={{ flex: 1, padding: '8px', backgroundColor: '#ffc107', color: '#000', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                    >
                        <i className="fas fa-pause"></i> Pausar
                    </button>
                )}

                <button
                    onClick={() => {
                        if (window.confirm('Tem certeza que deseja limpar toda a fila?')) handleControl('clear');
                    }}
                    style={{ flex: 1, padding: '8px', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                >
                    <i className="fas fa-trash"></i> Limpar
                </button>
            </div>

            <div style={{ marginBottom: '10px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.9rem', marginBottom: '5px' }}>
                    <span>Mensagens na fila:</span>
                    <strong>{queueState.size}</strong>
                </div>

                {/* Progress Bar Animation */}
                {queueState.isProcessing && (
                    <div style={{ height: '4px', backgroundColor: '#f0f0f0', borderRadius: '2px', overflow: 'hidden' }}>
                        <div className="progress-bar-animated" style={{
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'var(--primary-color)',
                            animation: 'progress 2s infinite linear'
                        }}></div>
                    </div>
                )}
            </div>

            {currentItem && (
                <div style={{ fontSize: '0.8rem', color: '#666', borderTop: '1px solid #eee', paddingTop: '8px' }}>
                    <i className="fas fa-spinner fa-spin"></i> Enviando item {currentItem.id.substr(0, 8)}...
                </div>
            )}

            {lastError && (
                <div style={{ fontSize: '0.8rem', color: '#dc3545', marginTop: '5px' }}>
                    <i className="fas fa-exclamation-circle"></i> Erro: {lastError}
                </div>
            )}

            <style>{`
                @keyframes progress {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(100%); }
                }
            `}</style>
        </div>
    );
};

export default QueueStatus;
